import {
  clearProfile,
  getProfile,
  getProfileBookings,
} from '@/features/profile/profileActions';
import type { CustomerProfileDetailsResponseDTO } from '@/types/dto/agent';
import type { BookingsState } from '@/types/profile';
import { createReducer } from '@reduxjs/toolkit';

export interface ProfileState {
  current: CustomerProfileDetailsResponseDTO | null;
  bookings: BookingsState | null;
}

const initialState: ProfileState = {
  current: null,
  bookings: null,
};

export const profileReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getProfile.fulfilled, (state, action) => {
      state.current = action.payload;
    })
    .addCase(clearProfile, (state) => {
      state.current = null;
      state.bookings = null;
    })
    .addCase(getProfileBookings.fulfilled, (state, action) => {
      state.bookings = action.payload;
    });
});
